import apiClient from './base/apiClient'

export interface University {
  id: number
  key: string
  name: string
  /** '@' 없이 온다. 화면에 보일 때만 앞에 붙인다. */
  domain: string
  logoPath: string | null
}

export interface UniversityMembership {
  email: string
  verifiedAt: string | null
  /** 소속 해제한 때. 값이 있으면 '다시 들어가기' 화면을 보여준다(메일 인증 없이 돌아온다). */
  leftAt: string | null
  university: University
}

export interface SendCodeResponse {
  success: boolean
  message: string
  expiresInSec: number
  resendAfterSec: number
}

export interface VerifyCodeResponse {
  verified: boolean
  message: string
  membership?: UniversityMembership
}

export const universityApi = {
  getUniversities: async (): Promise<University[]> => {
    const res = await apiClient.get<{ universities: University[] }>('/university/list')
    return res.data.universities
  },

  getMembership: async (): Promise<UniversityMembership | null> => {
    const res = await apiClient.get<{ membership: UniversityMembership | null }>('/university/me')
    return res.data.membership
  },

  sendCode: async (universityId: number, email: string): Promise<SendCodeResponse> => {
    const res = await apiClient.post<SendCodeResponse>('/university/send-code', {
      universityId,
      email,
    })
    return res.data
  },

  verifyCode: async (code: string): Promise<VerifyCodeResponse> => {
    const res = await apiClient.post<VerifyCodeResponse>('/university/verify-code', { code })
    return res.data
  },

  /** 학교 소속 해제. 줄은 서버에 남아서 같은 학교로는 인증 없이 돌아온다. */
  leave: async (): Promise<void> => {
    await apiClient.post('/university/leave')
  },

  /** 해제했던 학교로 다시 참여 — 메일 인증 없이 */
  rejoin: async (): Promise<void> => {
    await apiClient.post('/university/rejoin')
  },
}

/** 학교 그룹 순위의 한 줄 */
export interface UniversityGroupMember {
  rank: number
  userId: string
  nickname: string | null
  profileImage: string | null
  /** 공개 기록 수 */
  recordCount: number
  isMe: boolean
}

export interface UniversityGroup {
  university: Pick<University, 'id' | 'key' | 'name' | 'logoPath'>
  memberCount: number
  members: UniversityGroupMember[]
}

/** 같은 학교 인증자들의 기록 수 순위. 인증 안 했으면 서버가 403 을 준다. */
export const getUniversityGroup = async (): Promise<UniversityGroup> => {
  const res = await apiClient.get<UniversityGroup>('/university/group')
  return res.data
}
